import { Box, styled } from '@mui/material';

export const StyProjectionDetailsCellRenderer = styled(Box, {
    name: 'StyProjectionDetailsCellRenderer',
})(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiFormControl-root': {
        height: '33px',
        padding: 0,
        '& .MuiInputBase-root': {
            paddingBottom: 0,
            paddingTop: 0,
            height: '100%',
        },
        '& .MuiInputBase-root.Mui-disabled': {
            backgroundColor: theme.palette.lightGrey,
        },
        '& .MuiInputBase-input': {
            fontSize: '11px',
            height: 'inherit',
            lineHeight: '16px',
        },
    },
    // This removes the arrows in the input field that are present by default
    '& input[type=number]': {
        MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
    },
}));
